export default __webpack_public_path__ + "static/media/about-loggi-expresso.dcfa59aa.png";